export default __webpack_public_path__ + "static/media/ocean.411f0f06.mp3";